import Const from '../const';

export const errorTypes = {
  questionInput: 'questionInput',
  advisorSection: 'advisorSection',
  nickname: 'nickname',
  gender: 'gender',
  dateOfBirth: 'dateOfBirth',
  error: 'error',
  email: 'email',
  advisorId: 'advisorId',
  paymentError: 'paymentError',
  gracePeriodExceeded: 'gracePeriodExceeded'
};

export const errorText = {
  emailAlreadyRegistered: 'Email already registered',
  isRequired: 'is required',
  tokenExpired: 'token expired'
};

const notSavedErrorTypes = {
  intentId: 'intentId',
  intentIdDescription: 'intentIdDescription',
  state: 'state'
};

const setError = (error) => ({
  type: Const.application.error,
  error
});

const clearError = (errorType) => ({
  type: Const.application.clearError,
  errorType
});

const clearingErrors = (error) => {
  let clearedErrors = {};
  Object.keys(error).forEach((key) => {
    if (Object.keys(notSavedErrorTypes).includes(key)) return;
    if (Array.isArray(error[key])) {
      error[key].forEach((e) => {
        if (e === errorText.isRequired) return;
        clearedErrors = { ...clearedErrors,  [key]: error[key] };
      });
    } else clearedErrors = { ...clearedErrors, [key]: error[key] };
  });
  return clearedErrors;
};

export const setErrorAction = (error) => (dispatch) => {
  const clearedErrors = clearingErrors(error);
  if (Object.keys(clearedErrors).length > 0) dispatch(setError(clearedErrors));
};

export const clearErrorAction = (errorType) => (dispatch) => {
  dispatch(clearError(errorType));
};
